<template>
  <ion-app>
    <ion-fab :horizontal="menuButton.position === 'left' ? 'start' : 'end'" vertical="top" slot="fixed"
      v-show="isViewWithMenu() && !isPageWithOwnHeader && !isPrivacyPolicy && !isOfferSupplement">
      <ion-fab-button @click="openMenu()" class="menu-fab-button">
        <div class="menu-notification-flag" v-show="globalContext.showMenuNotification && menuButton.position !== 'left'
          "></div>
        <ion-icon :icon="menuOutline" class="app-icon"></ion-icon>
        <div class="menu-notification-flag" v-show="globalContext.showMenuNotification && menuButton.position == 'left'
          "></div>
      </ion-fab-button>
    </ion-fab>

    <ion-menu contentId="main" menuId="mainMenu" :side="menuButton.position === 'left' ? 'start' : 'end'" type="overlay"
      :swipe-gesture="false">
      <div class="menu-header-background menu-header">
        <div class="menu-logo">
          <img src="@/theme/liga-logo-white.png" alt="liga-logo" />
        </div>
        <ion-avatar slot="start">
          <ion-img :src="avatarUrl" v-show="avatarUrl !== ''"></ion-img>
          <img src="@/theme/user.png" v-show="avatarUrl == ''" />
        </ion-avatar>
        <ion-label v-if="isAuthenticated">{{ userFirstname }} {{ userLastname }}</ion-label>
        <div class="menu-header-subname" @click="navigate('account')" v-if="isAuthenticated">
          <span>Профиль</span>
          <ion-icon slot="icon-only" :icon="chevronForwardOutline"></ion-icon>
        </div>
        <ion-button v-if="!isAuthenticated" class="login-button" @click="navigate('login')">Вход</ion-button>
      </div>
      <ion-content class="menu-content">
        <ion-list class="menu-list">
          <ion-item @click="navigate('today')" :class="[isToday ? 'selected-route' : '', 'menu-item']">
            <ion-icon :icon="todayOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Сегодня</ion-label>
          </ion-item>
          <ion-item @click="navigate('programs')" :class="[isPrograms ? 'selected-route' : '', 'menu-item']" v-if="isAuthenticated">
            <ion-icon :icon="fileTrayFullOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тренировки</ion-label>
          </ion-item>
          <ion-item @click="navigate('playlist-list')" :class="[isPlaylistList ? 'selected-route' : '', 'menu-item']"
            v-if="isMobile && isAuthenticated">
            <ion-icon :icon="musicalNotesOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Миксы</ion-label>
          </ion-item>
          <ion-item @click="navigate('skills')" :class="[isSkills ? 'selected-route' : '', 'menu-item']"  v-if="isAuthenticated">
            <ion-icon :icon="schoolOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тренинги</ion-label>
          </ion-item>
          <ion-item @click="navigate('testing')" :class="[isTesting ? 'selected-route' : '', 'menu-item']" v-if="isAuthenticated && !globalContext.offlineMode">
            <ion-icon :icon="documentTextOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тестирование</ion-label>
          </ion-item>
          <ion-item @click="navigate('events')" :class="[isEvents ? 'selected-route' : '', 'menu-item']" v-if="isAuthenticated">
            <ion-icon :icon="calendarOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">События</ion-label>
          </ion-item>
          <ion-item @click="navigate('useful-links')" :class="[isUsefulLinks ? 'selected-route' : '', 'menu-item']" v-if="isAuthenticated">
            <ion-icon :icon="linkOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Полезные ссылки</ion-label>
          </ion-item>
          <ion-item @click="navigate('my-tickets')" :class="[isMyTickets ? 'selected-route' : '', 'menu-item']" v-if="isAuthenticated">
            <ion-icon :icon="ticketOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Мои билеты</ion-label>
          </ion-item>
          <ion-item-divider v-if="hasAnyAuthority('ROLE_MANAGER') && isAuthenticated">
            <ion-label class="menu-section-label">Администрирование</ion-label>
          </ion-item-divider>
          <ion-item @click="navigate('users')" :class="[isUsers ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority('ROLE_MANAGER') && isAuthenticated">
            <ion-icon :icon="peopleOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Пользователи</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-roles')" :class="[isAdminRoles ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority('ROLE_MANAGER') && isAuthenticated">
            <ion-icon :icon="keyOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Роли</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-education-sections')" :class="[isAdminEducationSections ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority('ROLE_MANAGER') && isAuthenticated">
            <ion-icon :icon="libraryOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Разделы тренингов</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-media-upload')" :class="[isAdminMediaUpload ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority('ROLE_MANAGER') && isAuthenticated">
            <ion-icon :icon="cloudUploadOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Медиатека</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-releases')" :class="[isAdminReleases ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority('ROLE_MANAGER') && isAuthenticated">
            <ion-icon :icon="fileTrayFullOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Релизы</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-payments')" :class="[isAdminPayments ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority('ROLE_MANAGER') && isAuthenticated">
            <ion-icon :icon="cardOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Оплаты</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-useful-links')" :class="[isAdminUsefulLinks ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority('ROLE_MANAGER') && isAuthenticated">
            <ion-icon :icon="linkOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Полезные ссылки (админ)</ion-label>
          </ion-item>
          <ion-item @click="navigate('admin-testing')" :class="[isAdminTesting ? 'selected-route' : '', 'menu-item']"
            v-if="hasAnyAuthority('ROLE_MANAGER') && isAuthenticated && !globalContext.offlineMode">
            <ion-icon :icon="documentTextOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тестирование</ion-label>
          </ion-item>
          <ion-item @click="openTelegramSupport()" class="menu-item" v-if="!globalContext.offlineMode">
            <ion-icon :icon="chatbubbleOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Техподдержка</ion-label>
          </ion-item>
          <ion-item @click="navigate('settings')" :class="[isSettings ? 'selected-route' : '', 'menu-item']">
            <ion-icon :icon="settingsOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Настройки</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
      <ion-footer class="menu-footer">
        <ion-toolbar translucent class="app-footer-style">
          <ion-title class="ion-text-center menu-footer" @click="checkAppUpdate()">Версия {{ appVersion }}</ion-title>
          <div class="menu-footer-links">
            <a :href="LEGAL.offerUrl" target="_blank" rel="noopener noreferrer" class="menu-footer-link">Оферта</a>
            <span class="menu-footer-sep">|</span>
            <span @click="navigate('privacy-policy')" class="menu-footer-link">Конфиденциальность</span>
            <span class="menu-footer-sep">|</span>
            <span @click="navigate('offer-supplement')" class="menu-footer-link">Возвраты</span>
          </div>
          <p class="menu-footer-payee">Платежи принимает: <a :href="LEGAL.offerUrl" target="_blank" rel="noopener noreferrer" class="menu-footer-link">{{ LEGAL.payeeShortName }}</a></p>
        </ion-toolbar>
      </ion-footer>
    </ion-menu>

    <ion-menu contentId="main" menuId="offlineMenu" :side="menuButton.position === 'left' ? 'start' : 'end'"
      type="overlay" :swipe-gesture="false">
      <div class="menu-header-background menu-header">
        <div class="menu-logo">
          <img src="@/theme/liga-logo-white.png" alt="liga-logo" />
        </div>
        <ion-avatar slot="start">
          <ion-img :src="avatarUrl" v-show="avatarUrl !== ''"></ion-img>
          <img src="@/theme/user.png" v-show="avatarUrl == ''" />
        </ion-avatar>
        <ion-label>{{ userFirstname }} {{ userLastname }}</ion-label>
        <div class="menu-header-subname" @click="navigate('account')">
          <span>Профиль</span>
          <ion-icon slot="icon-only" :icon="chevronForwardOutline"></ion-icon>
        </div>
      </div>
      <ion-content class="menu-content">
        <ion-list class="menu-list">
          <ion-item @click="navigate('today')" :class="[isToday ? 'selected-route' : '', 'menu-item']">
            <ion-icon :icon="todayOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Сегодня</ion-label>
          </ion-item>
          <ion-item @click="navigate('programs')" :class="[isPrograms ? 'selected-route' : '', 'menu-item']">
            <ion-icon :icon="fileTrayFullOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тренировки</ion-label>
          </ion-item>
          <ion-item @click="navigate('playlist-list')" :class="[isPlaylistList ? 'selected-route' : '', 'menu-item']"
            v-if="isMobile">
            <ion-icon :icon="musicalNotesOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Миксы</ion-label>
          </ion-item>
          <ion-item @click="navigate('skills')" :class="[isSkills ? 'selected-route' : '', 'menu-item']" v-if="isMobile">
            <ion-icon :icon="schoolOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тренинги</ion-label>
          </ion-item>
          <ion-item @click="navigate('testing')" :class="[isTesting ? 'selected-route' : '', 'menu-item']" v-if="isMobile && !globalContext.offlineMode">
            <ion-icon :icon="documentTextOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Тестирование</ion-label>
          </ion-item>
          <ion-item @click="openTelegramSupport()" class="menu-item" v-if="!globalContext.offlineMode">
            <ion-icon :icon="chatbubbleOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Техподдержка</ion-label>
          </ion-item>
          <ion-item @click="navigate('settings')" :class="[isSettings ? 'selected-route' : '', 'menu-item']"
            v-if="isMobile">
            <ion-icon :icon="settingsOutline" class="app-icon"></ion-icon>
            <ion-label class="menu-label">Настройки</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
      <ion-footer class="menu-footer">
        <ion-toolbar translucent class="app-footer-style">
          <ion-title class="ion-text-center menu-footer">Версия {{ appVersion }}</ion-title>
          <div class="menu-footer-links">
            <a :href="LEGAL.offerUrl" target="_blank" rel="noopener noreferrer" class="menu-footer-link">Оферта</a>
            <span class="menu-footer-sep">|</span>
            <span @click="navigate('privacy-policy')" class="menu-footer-link">Конфиденциальность</span>
            <span class="menu-footer-sep">|</span>
            <span @click="navigate('offer-supplement')" class="menu-footer-link">Возвраты</span>
          </div>
          <p class="menu-footer-payee">Платежи принимает: <a :href="LEGAL.offerUrl" target="_blank" rel="noopener noreferrer" class="menu-footer-link">{{ LEGAL.payeeShortName }}</a></p>
        </ion-toolbar>
      </ion-footer>
    </ion-menu>

    <ion-tabs>
      <ion-router-outlet id="main"></ion-router-outlet>

      <div :class="['music-player-container', !showReleaseTabs() && !showTodayTabs() ? 'music-player-bottom-container' : '']" v-show="playerBar.visible && !playerBar.microMode">
        <audio ref="audioRef" preload="metadata" v-if="!isMobile">
          <source :src="trackPath" type="audio/mpeg" />
        </audio>

        <div class="w-player" v-show="!showPlayList">
          <div class="w-track-name">
            {{
              playerBar.currentTrackIdx !== undefined &&
              playerBar.musicList !== undefined &&
              playerBar.musicList[playerBar.currentTrackIdx] !== undefined
              ? mediaUtils.getTrackName(
                playerBar.musicList[playerBar.currentTrackIdx]
              )
              : ""
            }}
          </div>
          <div class="w-playlist-name">
            {{ playerBar.playlistName }}
          </div>
          <div class="w-player-range">
            <vue-slider :lazy="true" v-model="playerBar.currentPosition" :min="0" :max="playerBar.currentDuration"
              @dragging="rangeDragging" @dragStart="rangeDragStart()" @dragEnd="rangeDragEnd()" tooltip="none"
              :drag-on-click="true">
            </vue-slider>
          </div>
          <div class="player-label player-current-time">
            {{ playerBar.currentTrackCurrentTime }}
          </div>
          <div class="player-label player-total-time">
            {{
              playerBar.musicList && playerBar.musicList.length > 0
              ? mediaUtils.formatTime(
                playerBar.musicList[playerBar.currentTrackIdx].duration -
                playerBar.currentPosition
              )
              : "--:--"
            }}
          </div>
          <div class="w-player-buttons">
            <ion-button class="player-button player-extended-sm-button" :disabled="isFM()" @click="prevAudioTrack()">
              <ion-icon :icon="playSkipBack" class="player-button-icon"></ion-icon>
            </ion-button>
            <ion-button class="player-button player-extended-sm-button" :disabled="isFM()" @click="playBackTrack()">
              <ion-icon :icon="playBack" class="player-button-icon"></ion-icon>
            </ion-button>
            <ion-button class="player-button" @click="changeCurrentPosition(-15)">
              -15
            </ion-button>
            <ion-button class="player-button player-extended-l-button" slot="end"
              @click="playerControls(!playerBar.playing)">
              <ion-icon :icon="play" class="player-button-icon"
                v-show="!playerBar.playing && (!isMobile || playerBar.isReady)"></ion-icon>
              <ion-icon :icon="pause" class="player-button-icon"
                v-show="playerBar.playing && (!isMobile || playerBar.isReady)"></ion-icon>
              <ion-spinner name="bubbles" v-show="isMobile && !playerBar.isReady"></ion-spinner>
            </ion-button>
            <ion-button class="player-button" @click="changeCurrentPosition(15)">
              +15
            </ion-button>
            <ion-button class="player-button player-extended-sm-button" @click="nextAudioTrack()">
              <ion-icon :icon="playSkipForward" class="player-button-icon"></ion-icon>
            </ion-button>
          </div>
          <div class="w-service-player-buttons">
            <ion-button class="player-button" @click="extendPlayerOnTrackName()" :disabled="isFM()">
              <ion-icon :icon="menuOutline" class="player-button-icon"></ion-icon>
            </ion-button>
            <ion-button class="player-button" @click="toMicroMode()" v-show="false">
              <ion-icon :icon="contractOutline" class="player-button-icon"></ion-icon>
            </ion-button>
            <ion-button class="player-button" @click="closePlayer()">
              <ion-icon :icon="closeOutline" class="player-button-icon"></ion-icon>
            </ion-button>
          </div>
      </div>

        <transition name="playlist-player">
          <div class="w-full-player" v-show="showPlayList && !isFM()">
            <div class="w-full-player-header">
              <ion-button class="playlist-collapse-button" @click="toExtendedPlayer()">
                <ion-icon :icon="chevronDownOutline" class="player-button-icon"></ion-icon>
              </ion-button>
              <img :src="playerAlbumImage" v-if="playerBar.playlistImage && '' !== playerBar.playlistImage
                " />
              <div class="playlist-header-text-wrapper">
                <p>
                  {{ playerBar.musicList.length }} Треков &#183;
                  {{
                    mediaUtils.formatTime(
                      mediaUtils.getTotalPlaylistDuration(playerBar.musicList)
                    )
                  }}
                  /
                  <span class="orange-regular">{{
                    mediaUtils.formatTime(
                      mediaUtils.getTotalPlaylistDurationFromIndex(
                        playerBar.musicList,
                        playerBar.currentTrackIdx
                      ) - playerBar.currentPosition
                    )
                  }}</span>
                </p>
                <h1>
                  {{
                    playerBar.currentTrackIdx !== undefined &&
                    playerBar.musicList !== undefined &&
                    playerBar.musicList[playerBar.currentTrackIdx] !==
                    undefined
                    ? mediaUtils.getTrackNameShort(
                      playerBar.musicList[playerBar.currentTrackIdx]
                    )
                    : ""
                  }}
                </h1>
                <h3>
                  {{ playerBar.playlistName }}
                </h3>

                <div class="playlist-play-button-wrapper">
                  <ion-button class="playlist-play-button" @click="playerControls(!playerBar.playing)">
                    <ion-icon :icon="play" class="player-button-icon"
                      v-show="!playerBar.playing && playerBar.isReady"></ion-icon>
                    <ion-icon :icon="pause" class="player-button-icon"
                      v-show="playerBar.playing && playerBar.isReady"></ion-icon>
                    <ion-spinner name="bubbles" v-show="!playerBar.isReady"></ion-spinner>
                  </ion-button>
                  <ion-button class="playlist-play-button playlist-play-button-sm" @click="prevAudioTrack()">
                    <ion-icon :icon="playSkipBack" class="player-button-icon"></ion-icon>
                  </ion-button>
                  <ion-button class="playlist-play-button playlist-play-button-sm" @click="playBackTrack()" v-if="false">
                    <ion-icon :icon="playBack" class="player-button-icon"></ion-icon>
                  </ion-button>
                  <ion-button class="playlist-play-button playlist-play-button-sm" @click="nextAudioTrack()">
                    <ion-icon :icon="playSkipForward" class="player-button-icon"></ion-icon>
                  </ion-button>
                </div>
              </div>
            </div>
            <div class="w-full-player-range">
              <div class="player-label playlist-current-time">
                {{ playerBar.currentTrackCurrentTime }}
              </div>
              <div class="player-label playlist-total-time">
                {{
                  playerBar.musicList && playerBar.musicList.length > 0
                      ? mediaUtils.formatTime(
                          playerBar.musicList[playerBar.currentTrackIdx]
                              .duration - playerBar.currentPosition
                      )
                      : "--:--"
                }}
              </div>
              <div class="player-range player-playlist-range">
                <vue-slider :lazy="true" v-model="playerBar.currentPosition" :min="0" :max="playerBar.currentDuration"
                            @dragging="rangeDragging" @dragStart="rangeDragStart()" @dragEnd="rangeDragEnd()" tooltip="none"
                            :drag-on-click="true">
                </vue-slider>
              </div>
            </div>
            <ion-list class="player-playlist" lines="none">
              <ion-item v-for="(audioTrack, idx) in playerBar.musicList" :key="audioTrack.id"
                @click="selectTrackAndPlay(idx)" class="player-item">
                <ion-label :class="[
                  playerBar.currentTrackIdx === idx ? 'selected-track' : '',
                  'playlist-label',
                ]">{{ mediaUtils.getTrackNameShort(audioTrack) }}</ion-label>
                <ion-note :class="[
                  playerBar.currentTrackIdx === idx ? 'selected-track' : '',
                ]" slot="end">{{ mediaUtils.formatTime(audioTrack.duration) }}</ion-note>
              </ion-item>
            </ion-list>
            <ion-item class="fake-footer bg-transparent" lines="none">
            </ion-item>
          </div>
        </transition>
      </div>

      <div :class="['micro-player-container', playerBar.microExtendedMode ? 'micro-player-container-ext' : '']" v-show="playerBar.microMode && playerBar.musicList.length > 0">
        <div class="micro-player">
          <div :class="['w-track-index', playerBar.microExtendedMode ? 'w-track-index-ext' : '']" @click="playerBar.microExtendedMode = !playerBar.microExtendedMode">
            {{ playerBar.currentTrackIdx + 1 }}
            <div class="micro-track-time">
              {{ playerBar.currentTrackCurrentTime }}
            </div>
          </div>
          <div class="micro-player-controls" v-show="playerBar.microExtendedMode">
            <div class="micro-player-buttons">
              <ion-button class="player-button player-extended-sm-button" :disabled="isFM()" @click="prevAudioTrack()">
                <ion-icon :icon="playSkipBack" class="player-button-icon"></ion-icon>
              </ion-button>
              <ion-button class="player-button player-extended-sm-button" :disabled="isFM()" @click="playBackTrack()">
                <ion-icon :icon="playBack" class="player-button-icon"></ion-icon>
              </ion-button>
              <ion-button class="player-button" @click="changeCurrentPosition(-15)">
                -15
              </ion-button>
              <ion-button class="player-button player-extended-l-button" slot="end"
                          @click="playerControls(!playerBar.playing)">
                <ion-icon :icon="play" class="player-button-icon"
                          v-show="!playerBar.playing && (!isMobile || playerBar.isReady)"></ion-icon>
                <ion-icon :icon="pause" class="player-button-icon"
                          v-show="playerBar.playing && (!isMobile || playerBar.isReady)"></ion-icon>
                <ion-spinner name="bubbles" v-show="isMobile && !playerBar.isReady"></ion-spinner>
              </ion-button>
              <ion-button class="player-button" @click="changeCurrentPosition(15)">
                +15
              </ion-button>
              <ion-button class="player-button player-extended-sm-button" @click="nextAudioTrack()">
                <ion-icon :icon="playSkipForward" class="player-button-icon"></ion-icon>
              </ion-button>
            </div>
          </div>
          <div class="player-range micro-range">
            <vue-slider :lazy="true" v-model="playerBar.currentPosition" :min="0" :max="playerBar.currentDuration"
                        @dragging="rangeDragging" @dragStart="rangeDragStart()" @dragEnd="rangeDragEnd()" tooltip="none"
                        :drag-on-click="true" :dotSize="playerBar.microExtendedMode ? 8 : 5">
            </vue-slider>
          </div>
        </div>
      </div>

      <ion-modal ref="playNowModal" @didDismiss="() => {
          showPlayNow = false;
        }
        " :can-dismiss="true" :breakpoints="[0.5, 0.8, 1]" :initialBreakpoint="0.5" :is-open="showPlayNow"
        :handle="false" class="play-now-container">
        <ion-content>
          <div>
            <ion-button @click="playNowNavigate('programs')">
              <ion-label>Тренировки</ion-label>
            </ion-button>
            <ion-button v-show="isMobile" @click="playNowNavigate('playlist-list')">
              <ion-label>Миксы</ion-label>
            </ion-button>
            <ion-button :disabled="playerBar.musicList.length < 1" @click="playNow()">
              <ion-label>Сейчас:
                {{
                  playerBar.playlistName.length > 0 ? playerBar.playlistName : "-"
                }}</ion-label>
            </ion-button>
            <ion-button @click="showPlayNow = false" class="cancel-button">
              <ion-label>
                Закрыть
              </ion-label>
            </ion-button>
          </div>
        </ion-content>
      </ion-modal>

      <ion-tab-bar slot="bottom" v-show="showReleaseTabs()" class="modern-tab-bar" :class="{ 'tab-bar-web': !isMobile }">
        <ion-tab-button class="modern-tab-button" @click="navigate('Programs')">
          <div class="tab-icon-wrapper">
            <ion-icon :icon="fileTrayFullOutline"></ion-icon>
          </div>
          <span class="tab-label">Назад</span>
        </ion-tab-button>
        <ion-tab-button tab="music" href="/music" target="release-router" class="modern-tab-button">
          <div class="tab-icon-wrapper">
            <ion-icon :icon="musicalNotesOutline"></ion-icon>
          </div>
          <span class="tab-label">Музыка</span>
        </ion-tab-button>
        <ion-tab-button tab="video" href="/video" target="release-router" class="modern-tab-button">
          <div class="tab-icon-wrapper">
            <ion-icon :icon="filmOutline"></ion-icon>
          </div>
          <span class="tab-label">Видео</span>
        </ion-tab-button>
        <ion-tab-button tab="guide" href="/guide" target="release-router" class="modern-tab-button">
          <div class="tab-icon-wrapper">
            <ion-icon :icon="documentOutline"></ion-icon>
          </div>
          <span class="tab-label">Гайды</span>
        </ion-tab-button>
      </ion-tab-bar>

      <ion-tab-bar slot="bottom" v-show="showTodayTabs()" v-if="isAuthenticated" class="modern-tab-bar" :class="{ 'tab-bar-web': !isMobile }">
        <ion-tab-button
          tab="workouts"
          href="/programs"
          target="today-router"
          :class="[{ selected: isActive('workouts') }, 'modern-tab-button']"
        >
          <div class="tab-icon-wrapper">
            <ion-icon :icon="listOutline"></ion-icon>
          </div>
          <span class="tab-label">Программы</span>
        </ion-tab-button>
        
        <ion-tab-button
          tab="playlists"
          href="/playlist-list"
          target="today-router"
          :class="[{ selected: isActive('playlists') }, 'modern-tab-button']"
        >
          <div class="tab-icon-wrapper">
            <ion-icon :icon="playOutline"></ion-icon>
          </div>
          <span class="tab-label">Миксы</span>
        </ion-tab-button>

        <ion-tab-button
          tab="skills"
          href="/skills"
          target="today-router"
          :class="[{ selected: isActive('skills') }, 'modern-tab-button']"
        >
          <div class="tab-icon-wrapper">
            <ion-icon :icon="schoolOutline"></ion-icon>
          </div>
          <span class="tab-label">Образование</span>
        </ion-tab-button>
      </ion-tab-bar>

    </ion-tabs>

    <!-- <BottomCustomMenu 
      @menu-click="openMenu"
      @center-click="centerAction"
      @settings-click="openSettings"
    /> -->

    <ion-toast cssClass="custom-toast" :is-open="lostNetwork" message="Пропал интернет. Переходим в оффлайн."
      :duration="1200" position="middle" color="dark" @didDismiss="openNetworkToast(false)">
    </ion-toast>

    <ion-modal css-class="liga-modal-loading" :is-open="globalContext.isLoading" :backdropDismiss="false">
      <div class="liga-loading-container">
        <div class="liga-loading-go-offline" @click="goOfflineAndStopLoading()">
          <ion-icon :icon="cloudOffline"></ion-icon>
        </div>
        <p class="liga-loading-header">Загрузка</p>
        <img :src="require(`@/theme/liga-logo-black.png`)" alt="loading image" />
        <p class="liga-loading-header">ПОГОДИ, ЩА ВСЕ БУДЕТ</p>
        <ion-spinner name="bubbles"></ion-spinner>
      </div>
    </ion-modal>

    <!-- Модальное окно согласия с политикой конфиденциальности (при первом входе) -->
    <ion-modal
      :is-open="showPrivacyConsentModal"
      :backdrop-dismiss="false"
      class="privacy-consent-modal"
      @didDismiss="showPrivacyConsentModal = false">
      <ion-header>
        <ion-toolbar>
          <ion-title>Согласие с условиями</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <p class="privacy-consent-text">
          Национальная лига тренеров обрабатывает ваши персональные данные в соответствии с Политикой конфиденциальности и Договором оферты. Продолжая использовать приложение, вы подтверждаете согласие с этими документами.
        </p>
        <p>
          <a href="#" @click.prevent="openPrivacyPolicy()" class="privacy-consent-link">Политика конфиденциальности</a>
        </p>
        <p>
          <a :href="privacyOfferUrl" target="_blank" rel="noopener noreferrer" class="privacy-consent-link">Договор оферты</a>
        </p>
        <ion-button expand="block" class="privacy-consent-accept-btn" @click="acceptPrivacyConsent()">
          Принимаю
        </ion-button>
      </ion-content>
    </ion-modal>
  </ion-app>
</template>

<script lang="ts">
// import BottomCustomMenu from '@/BottomCustomMenu.vue';
import { LEGAL } from '@/config/legal';
import MediaUtils from "@/services/media.utils";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation";
import { App } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { Capacitor, CapacitorHttp } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { Network } from "@capacitor/network";
import { Preferences } from "@capacitor/preferences";
import { SplashScreen } from "@capacitor/splash-screen";
import { StatusBar, Style } from "@capacitor/status-bar";
import {
  Gesture,
  IonApp,
  IonAvatar,
  IonButton,
  IonContent,
  IonFab,
  IonFabButton,
  IonFooter,
  IonHeader,
  IonIcon,
  IonImg,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,
  IonMenu,
  IonModal,
  IonNote,
  IonRouterOutlet,
  IonSpinner,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonTitle,
  IonToast,
  IonToolbar,
  createGesture,
  isPlatform,
  menuController,
  useBackButton,
} from "@ionic/vue";
import { AudioTrack, RmxAudioPlayer } from "capacitor-plugin-playlist";
import dayjs from "dayjs";
import {
  apps,
  calendarOutline,
  cardOutline,
  chatbubbleOutline,
  chevronDownOutline,
  chevronForwardOutline,
  chevronUpOutline,
  closeOutline,
  cloudOffline,
  cloudUploadOutline,
  contractOutline,
  documentOutline,
  documentTextOutline,
  fileTrayFullOutline,
  filmOutline,
  gridOutline,
  helpOutline,
  keyOutline,
  libraryOutline,
  linkOutline,
  listOutline,
  menuOutline,
  musicalNotesOutline,
  newspaperOutline,
  paperPlaneOutline,
  pause,
  pauseOutline,
  peopleOutline,
  personOutline,
  play,
  playBack,
  playForward,
  playOutline,
  playSkipBack,
  playSkipBackOutline,
  playSkipForward,
  playSkipForwardOutline,
  readerOutline,
  reloadOutline,
  reorderTwoOutline,
  repeatOutline,
  rocketOutline,
  schoolOutline,
  settingsOutline,
  starOutline,
  statsChartOutline,
  ticketOutline,
  timeOutline,
  timerOutline,
  todayOutline,
} from "ionicons/icons";
import {
  defineComponent,
  inject,
  onMounted,
  provide,
  reactive,
  ref,
} from "vue";
import { MenuButton } from "./model/menubutton.model";
import { PlayerBar } from "./model/playerbar.model";
import { Release } from "./model/release.model";
import AccountService from "./services/account.service";
// @ts-ignore
import { MittEmitter } from "mitt-emitter";
import { CalendarType } from "./model/calendartype.model";
import { GlobalContext } from "./model/globalcontext.model";
import { GoogleMedia } from "./model/googlemedia.model";
import { PlayerModes } from "./model/player.mode";
import router from "./router";
import CalendarService from "./services/calendar.service";
import FilesystemCustomUtils from "./services/filesystem.custom.utils";
import LogoService from "./services/logo.service";
import store from "./store";

export default defineComponent({
  name: "App",
  setup() {
    StatusBar.setStyle({ style: Style.Dark }).catch(() => { });

    const AVATAR_FILE_NAME = "liga-avatar.jpeg";
    const menuButton = inject("menuButton") as MenuButton;
    const accountService = inject("accountService") as AccountService;
    const calendarService = inject("calendarService") as CalendarService;
    const playerBarInit = inject("playerBar") as PlayerBar;
    const playerBar = reactive(playerBarInit);
    const releaseEntity = inject("release") as Release;
    const audioRef = ref();
    const emitter = inject("emitter") as MittEmitter;
    const globalContextInit = inject("globalContext") as GlobalContext;
    const mediaUtils = new MediaUtils();
    const isMobile = globalContextInit.isMobile;
    const globalContext = reactive(globalContextInit);
    provide("globalContext", globalContext);
    const audioPlayer = inject("audioPlayer") as RmxAudioPlayer;
    const playNowModal = ref();
    const microPlayerDragger = ref();

    const filesystemCustomUtils = new FilesystemCustomUtils();

    const lostNetwork = ref(false);
    const openNetworkToast = (state: boolean) => (lostNetwork.value = state);

    const showPrivacyConsentModal = ref(false);
    const privacyConsentCheckDone = ref(false);
    const privacyOfferUrl = LEGAL.offerUrl;

    const mimeExtensions: Map<string, string> = new Map([
      ["image/jpeg", "jpg"],
      ["image/png", "png"],
      ["application/json", "json"],
      ["audio/mpeg", "mp3"],
      ["video/mp4", "mp4"],
      ["video/mpeg", "mpeg"],
      ["video/quicktime", "mov"],
      ["application/pdf", "pdf"],
    ]);

    const calendarsDic = [
      new CalendarType("liga-team", "liga.Team", "#33b679"),
    ];

    onMounted(async () => {
      const menuButtonRight = await Preferences.get({ key: "menuButtonRight" });
      menuButton.position = menuButtonRight.value || "left";
      Preferences.get({ key: "musicBeta" }).then((value) => {
        globalContext.musicBeta = "1" === value.value;
      });
      Preferences.get({ key: "videoBeta" }).then((value) => {
        globalContext.videoBeta = "1" === value.value;
      });
      Preferences.get({ key: "syncVideoGuide" }).then((value) => {
        globalContext.syncVideoGuide = "1" === value.value;
      });

      SplashScreen.hide();

      // Показать окно согласия с политикой конфиденциальности при первом входе (если пользователь авторизован)
      const checkPrivacyConsent = async () => {
        if (privacyConsentCheckDone.value || !accountService.authenticated) return;
        privacyConsentCheckDone.value = true;
        const res = await Preferences.get({ key: "privacy_consent_accepted" });
        if (res.value !== "true") {
          showPrivacyConsentModal.value = true;
        }
      };
      setTimeout(checkPrivacyConsent, 1500);
    });

    // Показать окно согласия после входа (при переходе на главную страницу)
    const skipRoutesConsent = ["Login", "SignUp", "ResetPassword", "BadConnection"];
    router.afterEach(async (to) => {
      if (!to.name || skipRoutesConsent.includes(to.name as string) || !accountService.authenticated || privacyConsentCheckDone.value) return;
      privacyConsentCheckDone.value = true;
      const res = await Preferences.get({ key: "privacy_consent_accepted" });
      if (res.value !== "true") {
        showPrivacyConsentModal.value = true;
      }
    });

    const openPrivacyPolicy = () => {
      showPrivacyConsentModal.value = false;
      router.push("/privacy-policy");
    };

    const acceptPrivacyConsent = async () => {
      await Preferences.set({ key: "privacy_consent_accepted", value: "true" });
      showPrivacyConsentModal.value = false;
    };

    useBackButton(10, () => {
      router.replace("/today");
    });

    if (isMobile) {
      audioPlayer.on("status", (statusCallback) => {
        if (undefined === statusCallback || undefined === statusCallback.value)
          return;

        console.log('statusCallback', statusCallback);

        if ("duration" in statusCallback.value) {
          if (statusCallback.value.duration > 0) {
            playerBar.currentTrackTotalTime = mediaUtils.formatTime(
              statusCallback.value.duration
            );
            playerBar.currentDuration = Math.floor(statusCallback.value.duration);
          }
        }
        if ("currentPosition" in statusCallback.value) {
          playerBar.currentPosition = statusCallback.value.currentPosition;
          playerBar.currentTrackCurrentTime = mediaUtils.formatTime(
            statusCallback.value.currentPosition
          );
          playerBar.playingProgress =
            100 - (playerBar.currentPosition / playerBar.currentDuration) * 100;
        }
        if (
          "currentIndex" in statusCallback.value &&
          audioPlayer.isPlaying
        ) {
          if (
            statusCallback.value.currentIndex !== playerBar.currentTrackIdx
          ) {
            playerBar.currentTrackIdx = statusCallback.value.currentIndex;
          }
        }
        if ("status" in statusCallback.value) {
          playerBar.isReady = "loading" !== statusCallback.value.status;

          if (statusCallback.value.status === "playing") {
            playerBar.currentTrackTotalTime = mediaUtils.formatTime(
              playerBar.musicList[playerBar.currentTrackIdx].duration
            );
            playerBar.playing = true;
            playerBar.paused = false;
            playerBar.visible = !playerBar.microMode && router.currentRoute.value.path !== "/video";
          } else if (statusCallback.value.status === "paused") {
            playerBar.playing = false;
            playerBar.paused = true;
          } else if (statusCallback.value.status === "error") {
            // this.emitter.emit("music-player-loaded-list", true);
          }
        }
      });
    }

    return {
      todayOutline,
      readerOutline,
      schoolOutline,
      documentTextOutline,
      listOutline,
      personOutline,
      chevronForwardOutline,
      menuOutline,
      settingsOutline,
      peopleOutline,
      keyOutline,
      libraryOutline,
      cloudUploadOutline,
      playOutline,
      pauseOutline,
      play,
      pause,
      chevronDownOutline,
      chevronUpOutline,
      contractOutline,
      closeOutline,
      playSkipBackOutline,
      playSkipForwardOutline,
      playSkipBack,
      playSkipForward,
      playForward,
      timeOutline,
      timerOutline,
      musicalNotesOutline,
      filmOutline,
      documentOutline,
      reloadOutline,
      menuButton,
      accountService,
      playerBar,
      releaseEntity,
      audioRef,
      emitter,
      mimeExtensions,
      globalContext,
      mediaUtils,
      isMobile,
      helpOutline,
      audioPlayer,
      apps,
      repeatOutline,
      calendarService,
      lostNetwork,
      openNetworkToast,
      AVATAR_FILE_NAME,
      rocketOutline,
      fileTrayFullOutline,
      paperPlaneOutline,
      calendarsDic,
      starOutline,
      newspaperOutline,
      gridOutline,
      statsChartOutline,
      playNowModal,
      filesystemCustomUtils,
      reorderTwoOutline,
      microPlayerDragger,
      cloudOffline,
      calendarOutline,
      linkOutline,
      ticketOutline,
      cardOutline,
      chatbubbleOutline,
      playBack,
      showPrivacyConsentModal,
      privacyOfferUrl,
      LEGAL,
      openPrivacyPolicy,
      acceptPrivacyConsent,
      // BottomCustomMenu
    };
  },
  components: {
    IonApp,
    IonRouterOutlet,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonFab,
    IonFabButton,
    IonMenu,
    IonFooter,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonItemDivider,
    IonLabel,
    IonNote,
    IonButton,
    IonToast,
    IonAvatar,
    IonImg,
    IonModal,
    IonSpinner,
  },
  data() {
    return {
      appVersion: "-",
      hasAnyAuthorityValue: false,
      showPlayList: false,
      isDragPlayerRange: false,
      showExtendedPlayer: false,
      showPlayerDelay: false,
      trackPath: "",
      isLandscapeMode: false,
      countClassesNeedReplace: 0,
      countClassesNeedAccept: 0,
      avatarUrl: "",
      userLastname: store.getters.account ? store.getters.account.lastName : "",
      userFirstname: store.getters.account
        ? store.getters.account.firstName
        : "",
      playerAlbumImage: "",
      logoService: new LogoService(),

      todayEventsCount: 0,
      todayNewsCount: 0,
      todaySectorFailsCount: 0,

      isPushEnabled: true,

      showPlayNow: false,

      downloadProcessRunning: false,
      downloadProcess: 0,
      microPlayerPosition: 0,
      pressTime: 0,
      updatedCurrentTime: 0,
    };
  },

  computed: {
    isAuthenticated: () => {
      return store.getters.authenticated;
    },
    isLogin() {
      return this.$router.currentRoute.value.name === "Login";
    },
    isSignUp() {
      return this.$router.currentRoute.value.name === "SignUp";
    },
    isResetPassword() {
      return this.$router.currentRoute.value.name === "ResetPassword";
    },
    isChangePassword() {
      return this.$router.currentRoute.value.name === "ChangePassword";
    },
    isWorkoutList() {
      return this.$router.currentRoute.value.name === "WorkoutList";
    },
    isToday() {
      return this.$router.currentRoute.value.name === "Today";
    },
    isTodayWorkouts() {
      return this.$router.currentRoute.value.name === "TodayWorkouts";
    },
    isTodayEvents() {
      return this.$router.currentRoute.value.name === "TodayEvents";
    },
    isTodayNews() {
      return this.$router.currentRoute.value.name === "TodayNews";
    },
    isTodaySector() {
      return this.$router.currentRoute.value.name === "TodaySector";
    },
    isInstructorReplace() {
      return this.$router.currentRoute.value.name === "InstructorReplace";
    },
    isReplacementCandidate() {
      return this.$router.currentRoute.value.name === "ReplacementCandidate";
    },
    isSummary() {
      return this.$router.currentRoute.value.name === "Summary";
    },
    isPrograms() {
      return this.$router.currentRoute.value.name === "Programs";
    },
    isPlaylistList() {
      return this.$router.currentRoute.value.name === "PlaylistList";
    },
    isSkills() {
      return this.$router.currentRoute.value.name === "Skills";
    },
    isTesting() {
      return this.$router.currentRoute.value.name === "Testing";
    },
    isEvents() {
      const name = this.$router.currentRoute.value.name;
      return name === "EventsList" || name === "EventDetail";
    },
    isMyTickets() {
      return this.$router.currentRoute.value.name === "MyTickets";
    },
    isUsefulLinks() {
      return this.$router.currentRoute.value.name === "UsefulLinks";
    },
    isAdminUsefulLinks() {
      return this.$router.currentRoute.value.name === "AdminUsefulLinks";
    },
    isEventPaymentSuccess() {
      return this.$router.currentRoute.value.name === "EventPaymentSuccess";
    },
    isReleasePage() {
      return this.$router.currentRoute.value.name === "ReleasePage";
    },
    isRelease() {
      return this.$router.currentRoute.value.name === "ReleaseMain";
    },
    isReleaseMusic() {
      return this.$router.currentRoute.value.path === "/music";
    },
    isReleaseVideo() {
      return this.$router.currentRoute.value.path === "/video";
    },
    isReleaseGuide() {
      return this.$router.currentRoute.value.path === "/guide";
    },
    isAccount() {
      return this.$router.currentRoute.value.name === "Account";
    },
    isCertification() {
      return this.$router.currentRoute.value.name === "Certification";
    },
    isMonthSheet() {
      return this.$router.currentRoute.value.name === "MonthSheet";
    },
    isMemories() {
      return this.$router.currentRoute.value.name === "Memories";
    },
    isCharts() {
      return this.$router.currentRoute.value.name === "Charts";
    },
    isUsers() {
      return this.$router.currentRoute.value.name === "Users";
    },
    isAdminRoles() {
      return this.$router.currentRoute.value.name === "AdminRoles";
    },
    isAdminEducationSections() {
      return this.$router.currentRoute.value.name === "AdminEducationSections";
    },
    isAdminMediaUpload() {
      return this.$router.currentRoute.value.name === "AdminMediaUpload";
    },
    isAdminReleases() {
      return this.$router.currentRoute.value.name === "AdminReleases";
    },
    isAdminPayments() {
      return this.$router.currentRoute.value.name === "AdminPayments";
    },
    isAdminVideoUpload() {
      return this.$router.currentRoute.value.name === "AdminVideoUpload";
    },
    isAdminTesting() {
      return this.$router.currentRoute.value.name === "AdminTesting";
    },
    isAdminEvents() {
      const name = this.$router.currentRoute.value.name;
      return name === "AdminEventsList" || name === "AdminEventNew" || name === "AdminEventEdit" || name === "AdminEventRegistrations";
    },
    isPageWithOwnHeader() {
      return this.isSkills || this.isTesting || this.isEvents || this.isEventPaymentSuccess || this.isMyTickets || this.isUsefulLinks || this.isUsers || this.isAdminRoles || this.isAdminMediaUpload || this.isAdminReleases || this.isAdminPayments || this.isAdminVideoUpload || this.isAdminEducationSections || this.isAdminTesting || this.isAdminEvents || this.isAdminUsefulLinks || this.isSettings || this.isPrograms || this.isPlaylistList;
    },
    isPrivacyPolicy() {
      return this.$router.currentRoute.value.name === 'PrivacyPolicy';
    },
    isOfferSupplement() {
      return this.$router.currentRoute.value.name === 'OfferSupplement';
    },
    isFeedback() {
      return this.$router.currentRoute.value.name === "Feedback";
    },
    isProgramFeedback() {
      return this.$router.currentRoute.value.name === "ProgramFeedback";
    },
    isProgramFeedbackResults() {
      return this.$router.currentRoute.value.name === "ProgramFeedbackResults";
    },
    isSettings() {
      return this.$router.currentRoute.value.name === "Settings";
    },
    isBadConnection() {
      return this.$router.currentRoute.value.name === "BadConnection";
    },
    isMicroMode(): boolean {
      return this.playerBar ? this.playerBar.microMode : false;
    },
    isPlaylistMode(): boolean {
      return this.playerBar
        ? this.playerBar.visible &&
        this.playerBar.currentMode === PlayerModes.PLAYLIST
        : false;
    },
    isPlayListView() {
      return this.$router.currentRoute.value.name === "PlayListView";
    },
    updatedCurrentTimeStr(): string {
      return this.mediaUtils.formatTime(this.updatedCurrentTime);
    },
    playingProgress(): number {
      return this.playerBar.playingProgress;
    }
  },

  beforeMount() {
    try {
      this.downloadProgramsLogo();
    } catch (ex) {
      console.error(ex);
    }
  },

  mounted() {
    // force init
    this.globalContext.showMenuNotification;
    this.globalContext.isManager;
    this.globalContext.offlineMode;

    App.getInfo()
      .then((appInfo) => {
        this.appVersion = appInfo.version + " (" + appInfo.build + ")";
      })
      .catch(() => {
        //not implemented
        this.appVersion = `${dayjs().year()}.${dayjs().month()}`;
      });

    Filesystem.readdir({
      path: "",
      directory: Directory.Data,
    }).then((response) => {
      const avatarFile = response.files.find((f) => {
        return f.name == this.AVATAR_FILE_NAME;
      });
      if (undefined !== avatarFile) {
        Filesystem.getUri({
          path: this.AVATAR_FILE_NAME,
          directory: Directory.Data,
        }).then((res) => {
          if (res.uri !== "")
            this.avatarUrl = Capacitor.convertFileSrc(res.uri);
        });
      }
    });

    try {
      if (this.isMobile) {
          this.isLandscapeMode =
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE ||
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY ||
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY;
        ScreenOrientation.onChange().subscribe(() => {
          this.isLandscapeMode =
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE ||
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY ||
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY;
        });
      }
    } catch (ex) {
      //not supported
    }

    this.$nextTick(() => {
      // this.initTabBarCounters();

      Network.addListener("networkStatusChange", (networkStatus) => {
        if (!networkStatus.connected) {
          this.openNetworkToast(true);
          this.globalContext.offlineMode = true;
        } else {
          this.globalContext.offlineMode = false;
        }
      });
      App.addListener("appStateChange", ({ isActive }) => {
        if (isActive) {
          Network.getStatus().then((status) => {
            if (!status.connected) {
              this.openNetworkToast(true);
            }
          });

          if (this.isMobile && this.playerBar.playing) {
            this.playerBar.visible = true;
            if (this.playerBar.currentMode == PlayerModes.PLAYLIST) {
              this.openPlayList();
            } else if (this.playerBar.currentMode == PlayerModes.EXTENDED) {
              this.showExtendedPlayer = true;
            } else if (this.playerBar.currentMode == PlayerModes.MICRO) {
              this.toMicroMode();
            }
          }
        }
      });

      if (!this.isMobile) {
        this.audioRef.addEventListener("timeupdate", () => {
          if (!this.isDragPlayerRange) {
            this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
              this.audioRef.currentTime
            );
            this.playerBar.currentPosition = this.audioRef.currentTime;
            this.playerBar.playingProgress =
              100 -
              (this.playerBar.currentPosition / this.playerBar.currentDuration) * 100;
          }
        });

        this.audioRef.addEventListener("ended", () => {
          ++this.playerBar.currentTrackIdx;
          if (
            this.playerBar.currentTrackIdx >
            this.playerBar.musicList.length - 1
          ) {
            this.playerBar.currentTrackIdx = 0;
          }
          this.selectTrackAndPlay(this.playerBar.currentTrackIdx);
        });

        this.audioRef.addEventListener("loadedmetadata", () => {
          this.playerBar.isReady = true;
          if (this.audioRef.duration) {
            this.playerBar.currentTrackTotalTime = this.mediaUtils.formatTime(
              this.audioRef.duration
            );
            this.playerBar.currentDuration = Math.floor(this.audioRef.duration);
          }
          if (this.audioRef.currentTime > 0) {
            this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
              this.audioRef.currentTime
            );
          }
          if (this.playerBar.playing) {
            this.audioRef.play();
          }
        });

        this.audioRef.addEventListener("error", () => {
          console.log(
            "audio error: " +
            this.audioRef.error.code +
            " " +
            this.audioRef.error.message
          );
        });

        this.audioRef.addEventListener("playing", () => {
          this.playerBar.playing = true;
        });

        this.audioRef.addEventListener("paused", () => {
          this.playerBar.playing = false;
        });
      }
    });

    this.emitter.on("music-player-loaded-list", async () => {
      this.playerBar.visible = true;
      if (this.isMobile) {
        this.playerBar.isReady = false;
        this.addMobileTracks(this.playerBar.musicList).then((tracks) => {
          this.audioPlayer.setPlaylistItems(tracks, {
            playFromPosition: 0,
            playFromId: this.playerBar.musicList[this.playerBar.currentTrackIdx].id,
              startPaused: true
            }).then(() => {
              this.selectTrackAndPlay(this.playerBar.currentTrackIdx);
          });
        });
      } else {
          this.selectTrackAndPlay(this.playerBar.currentTrackIdx);
      }
    });

    this.emitter.on("init-download-process", () => {
      this.downloadProcessRunning = true;
      this.downloadProcess = 0;
    });

    this.emitter.on("abort-download-process", () => {
      this.downloadProcessRunning = false;
      this.downloadProcess = 0;
    });

    this.emitter.on("music-player-restart", () => {
      this.selectTrack();
    });

    this.emitter.on("music-player-restart-and-play", () => {
      this.selectTrackAndPlay();
    });

    this.emitter.on("music-player-open-playlist", () => {
      this.showPlayList = true;
      this.playerBar.currentMode = PlayerModes.PLAYLIST;
      this.getAlbumImage();
    });

    this.emitter.on("music-player-open-extended", () => {
      this.playerBar.currentMode = PlayerModes.EXTENDED;
      this.showExtendedPlayer = true;
    });

    this.emitter.on("music-player-play", () => {
      if (this.isMobile) {
        this.audioPlayer.seekTo(this.playerBar.currentPosition).then(() => {
          this.audioPlayer.play();
        });
      } else {
        this.audioRef.play();
      }
      this.playerBar.playing = true;
      this.playerBar.paused = false;
    });

    this.emitter.on("music-player-pause", () => {
      if (this.isMobile) {
        if (this.audioPlayer) this.audioPlayer.pause();
      } else {
        if (this.audioRef) this.audioRef.pause();
      }
      this.playerBar.playing = false;
      this.playerBar.paused = true;
    });

    this.emitter.on("music-player-stop", () => {
      if (this.isMobile) {
        this.audioPlayer.pause();
      } else {
        if (this.audioRef) this.audioRef.pause();
      }
      this.playerBar.playing = false;
      this.playerBar.paused = true;
    });

    this.emitter.on("update-menu-notification", () => {
      this.globalContext.showMenuNotification;
    });

    this.emitter.on("open-menu", () => {
      this.openMenu();
    });

    if (this.microPlayerDragger && this.microPlayerDragger) {
      let pressInterval: ReturnType<typeof setInterval>;
      let lastY = 0;
      const DOUBLE_CLICK_THRESHOLD = 500;
      let lastOnStart = 0;

      const microDraggerGesture: Gesture = createGesture({
        el: this.microPlayerDragger,
        threshold: 0,
        gestureName: "drag-micro-player-gesture",
        gesturePriority: 32,
        onStart: (ev) => {
          const now = Date.now();

          if (Math.abs(now - lastOnStart) <= DOUBLE_CLICK_THRESHOLD) {
            this.toExtendedPlayer();
          } else {
            lastOnStart = now;
            this.playerControls(!this.playerBar.playing);
          }

          this.pressTime = 0;
          lastY = ev.currentY;
          this.updatedCurrentTime = this.playerBar.currentPosition;
          pressInterval = setInterval(() => {
            this.pressTime += 1;
          }, 1000);
        },
        onMove: (ev) => {
          if (
            [0, 1].includes(this.microPlayerPosition) &&
            ev.deltaX < 0 &&
            Math.abs(ev.deltaX) < 100 &&
            this.pressTime < 1
          ) {
            this.microPlayerDragger.style.transform = `translateX(${ev.deltaX / 10
              }px)`;
          } else if (
            [1, 2].includes(this.microPlayerPosition) &&
            ev.deltaX > 0 &&
            Math.abs(ev.deltaX) < 100 &&
            this.pressTime < 1
          ) {
            this.microPlayerDragger.style.transform = `translateX(${ev.deltaX / 10
              }px)`;
          } else if (this.pressTime > 1 && ev.deltaY != 0) {
            const delta = lastY - ev.currentY;
            lastY = ev.currentY;
            const timeShift =
              this.playerBar.currentPosition +
              Math.abs(delta) * (delta > 0 ? 1 : -1);
            if (timeShift > 0 && timeShift < this.playerBar.currentDuration) {
              this.updatedCurrentTime = timeShift;
              this.setCurrentPosition(this.updatedCurrentTime);
            }
          }
        },
        onEnd: (ev) => {
          this.pressTime = 0;
          this.updatedCurrentTime = 0;
          if (pressInterval) {
            clearInterval(pressInterval);
          }
          this.microPlayerDragger.style.transition = ".1s ease-out";
          let translateValue = 0;
          if (ev.deltaX > 100 && this.pressTime < 1) {
            if (this.microPlayerPosition == 2) {
              this.microPlayerPosition = 1;
              translateValue = 40;
            } else if (this.microPlayerPosition == 1) {
              this.microPlayerPosition = 0;
              translateValue = 0;
            }
          } else if (ev.deltaX < -100 && this.pressTime < 1) {
            if (this.microPlayerPosition == 0) {
              this.microPlayerPosition = 1;
              translateValue = 40;
            } else if (this.microPlayerPosition == 1) {
              this.microPlayerPosition = 2;
              translateValue = 80;
            }
          }
          if (translateValue != 0) {
            this.microPlayerDragger.style.transform = `translateX(${-1 * translateValue
              }vw)`;
          } else {
            this.microPlayerDragger.style.transform = "";
          }
        },
      });

      microDraggerGesture.enable();
      // console.log("gesture enabled");
    }
  },

  methods: {
    isActive(tab: string): boolean {
      return this.$route.path.includes(tab);
    },

    navigate(routeName: string): void {
      menuController.close();
      this.$router.push(`/${routeName}`);
    },

    goOfflineAndStopLoading(): void {
      this.globalContext.isLoading = false;
      this.globalContext.offlineMode = true;
    },

    playNowNavigate(routeName: string): void {
      this.navigate(routeName);
      this.showPlayNow = false;
    },
    playNow() {
      this.playerBar.visible = true;
      this.openPlayList();
      if (this.isMobile) {
        if (!this.audioPlayer.isPlaying) {
          this.emitter.emit("music-player-loaded-list", true);
        }
      } else {
        if (this.audioRef.paused) {
          this.emitter.emit("music-player-loaded-list", true);
        }
      }
      this.showPlayNow = false;
    },

    async downloadProgramsLogo() {
      if (!this.globalContext.offlineMode) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/liga-programs`,
          headers: { Authorization: `Bearer ${token}` },
          readTimeout: 60000,
        };

        try {
          const result = await CapacitorHttp.get(options);
          if (result && result.data && result.data.length > 0) {
            const allPrograms = result.data;
            const logoService = new LogoService();
            await logoService.downloadAllProgramLogos(allPrograms);
          }
        } catch (error) {
          console.error('Failed to download program logos:', error);
        }
      }
    },

    openMenu() {
      this.userLastname = store.getters.account
        ? store.getters.account.lastName
        : "";
      this.userFirstname = store.getters.account
        ? store.getters.account.firstName
        : "";

      if (this.globalContext.offlineMode) {
        menuController.enable(true, "offlineMenu");
        menuController.open("offlineMenu");
      } else {
        this.calendarService.countAllReplacements().then((result) => {
          this.countClassesNeedReplace = result.countNeedReplace;
          this.countClassesNeedAccept = result.countNeedAccept;
          this.globalContext.showMenuNotification = result.countNeedReplace > 0;
        });

        menuController.enable(true, "mainMenu");
        menuController.open("mainMenu");
      }
    },

    centerAction() {
      console.log('Center button clicked');
      
    },
    openSettings() {
      console.log('Settings clicked');
      
    },

    hasAnyAuthority(authorities: any): boolean {
      this.accountService
        .hasAnyAuthorityAndCheckAuth(authorities)
        .then((value) => {
          this.hasAnyAuthorityValue = value;
        });
      return this.hasAnyAuthorityValue;
    },
    isViewWithMenu() {
      return (
        !this.isLogin &&
        !this.isSignUp &&
          !this.isChangePassword &&
        !this.isResetPassword &&
        !this.isRelease &&
        !this.isReleasePage &&
        !this.isReleaseMusic &&
        !this.isReleaseVideo &&
        !this.isReleaseGuide &&
        !this.isReplacementCandidate &&
        !this.isPlaylistMode &&
        !this.isPlayListView &&
        !this.isProgramFeedback &&
        !this.isProgramFeedbackResults
      );
      // && !this.isBadConnection;
    },
    showReleaseTabs() {
      return (
        !this.isLandscapeMode &&
        (this.isRelease ||
          this.isReleaseMusic ||
          this.isReleaseVideo ||
          this.isReleaseGuide)
      );
    },
    showTodayTabs() {
      return (
        this.isToday ||
        this.isTodayWorkouts ||
        this.isTodayEvents ||
        this.isTodayNews ||
        this.isTodaySector ||
        (this.isSkills && !this.isLandscapeMode) ||
        this.isPlaylistList ||
        this.isPrograms
      );
    },
    extendPlayerOnTrackName() {
      if (!this.showExtendedPlayer) {
        this.showExtendedPlayer = true;
        this.playerBar.currentMode = PlayerModes.EXTENDED;
      } else if (!this.isFM()) {
        this.showPlayList = true;
        this.playerBar.currentMode = PlayerModes.PLAYLIST;
      }

      if (this.showPlayList) {
        this.getAlbumImage();
      }
    },
    toCompactPlayer() {
      this.playerBar.visible = true;
      this.playerBar.currentMode = PlayerModes.DEFAULT;
      this.playerBar.microMode = false;
      this.showExtendedPlayer = false;
      this.showPlayList = false;
      this.showPlayerDelay = false;
    },
    toExtendedPlayer() {
      this.playerBar.visible = true;
      this.playerBar.currentMode = PlayerModes.EXTENDED;
      this.playerBar.microMode = false;
      this.showExtendedPlayer = true;
      this.showPlayList = false;
      this.showPlayerDelay = false;
    },
    reloadPlaylist(refreshEvent?: CustomEvent) {
      this.emitter.emit("music-player-loaded-list", true);
      if (refreshEvent && refreshEvent.target) {
        if (this.isMobile) {
          this.audioPlayer.ready().then(() => {
            refreshEvent.detail.complete();
            this.audioPlayer.play();
          });
        } else {
          refreshEvent.detail.complete();
        }
      }
    },
    getCurrentTrackNum(): string {
      if (this.playerBar.musicList.length < 1) return "-";

      const trackNum = this.playerBar.currentTrackIdx + 1;
      return trackNum > 9 ? String(trackNum) : `0${trackNum}`;
    },
    openPlayList() {
      this.showPlayList = true;
      this.playerBar.currentMode = PlayerModes.PLAYLIST;
      if (this.showPlayList) {
        this.getAlbumImage();
      }
    },
    isFM(): boolean {
      return this.playerBar.isFM;
    },
    openDelaySettings() {
      this.showPlayerDelay = !this.showPlayerDelay;
    },
    closePlayer() {
      if (this.isMobile) {
          this.audioPlayer.pause();
      } else {
        this.audioRef.pause();
      }
      this.toCompactPlayer();
      this.playerBar.visible = false;
      this.playerBar.playing = false;
      this.playerBar.currentMode = PlayerModes.CLOSED;
    },
    toMicroMode() {
      this.playerBar.visible = false;
      this.playerBar.microMode = true;
      this.playerBar.currentMode = PlayerModes.MICRO;
    },
    playerControls(play: boolean) {
      this.playerBar.playing = play;
      if (play) {
        if (this.isMobile) {
          // this.emitter.emit("music-player-play", true);
          this.audioPlayer.seekTo(this.playerBar.currentPosition).then(() => {
            this.audioPlayer.play();
          });
          this.playerBar.playing = true;
          this.playerBar.paused = false;
        } else {
          if (this.audioRef.currentTime > 0) {
            this.audioRef.play();
          } else {
            this.getAudioTrack().then(() => {
              this.audioRef.load();
            });
          }
        }
      } else {
        if (this.isMobile) {
          // this.emitter.emit("music-player-pause", true);
          this.audioPlayer.pause();
        } else {
          this.audioRef.pause();
        }
      }
    },

    restartAudioPlayer(play?: boolean) {
      this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(0);
      this.playerBar.currentPosition = 0;
      if (this.isMobile) {
        this.audioPlayer.pause();
        if (play) {
          this.audioPlayer.seekTo(this.playerBar.currentPosition).then(() => {
            this.audioPlayer.play();
          });
        }
      } else {
        if (this.audioRef) {
          this.audioRef.pause();
          this.audioRef.currentTime = 0;
          this.audioRef.load();
          if (play) this.audioRef.play();
        }
      }
    },

    async getFmPlaylist(): Promise<void> {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/media-metadata/shuffle-audio`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
      };

      CapacitorHttp.get(options).then((response) => {
        this.playerBar.musicList = response.data;
        if (this.playerBar.musicList.length > 0) {
          this.playerBar.isFM = true;
          this.playerBar.playlistName = "liga.FM";
          this.emitter.emit("music-player-loaded-list", true);
        }
      });

      this.showPlayNow = false;
    },

    addMobileTrack(selectedTrack: GoogleMedia): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        this.getAudioTrack(selectedTrack.id, selectedTrack.mimeType).then(
          (trackPath) => {
            const albumArt = this.playerAlbumImage
              || (this.playerBar.playlistImageDir && this.playerBar.playlistImage
                ? `${this.playerBar.playlistImageDir}/${this.playerBar.playlistImage}`
                : "");
            this.audioPlayer
              .addItem({
                isStream: false,
                trackId: selectedTrack.id,
                assetUrl: trackPath,
                artist: "Liga.Team",
                albumArt,
                album: this.playerBar.playlistName,
                title: this.mediaUtils.getTrackName(selectedTrack),
              })
              .then(() => {
                resolve(true);
              })
              .catch(() => {
                resolve(false);
              });
          }
        );
      });
    },

    async addMobileTracks(
      selectedTracks: Array<GoogleMedia>
    ): Promise<Array<AudioTrack>> {
      const mobileTracks = new Array<AudioTrack>();
      for (let index = 0; index < selectedTracks.length; index++) {
        const selectedTrack = selectedTracks[index];
        const trackPath = await this.getAudioTrack(
          selectedTrack.id,
          selectedTrack.mimeType
        );
        let albumArt: string;
        if (this.playerBar.programShortName) {
          albumArt = await this.logoService.getProgramLogo(this.playerBar.programShortName);
        } else {
          albumArt = await this.getTrackImageUri(
            `${this.playerBar.playlistImageDir}/${this.playerBar.playlistImage}`
          );
        }

        mobileTracks.push({
          isStream: false,
          trackId: selectedTrack.id,
          assetUrl: trackPath,
          artist: "Liga.Team",
          albumArt,
          album: this.playerBar.playlistName,
          title: this.mediaUtils.getTrackName(selectedTrack),
        });
      }
      return mobileTracks;
    },

    getTrackImageUri(path: string): Promise<string> {
      return new Promise<string>((resolve) => {
        Filesystem.getUri({
          path: path,
          directory: Directory.Data,
        })
          .then((result) => {
            resolve(result.uri.replaceAll("file://", ""));
          })
          .catch(() => {
            resolve("");
          });
      });
    },

    selectTrack(idx?: number) {
      if (typeof idx !== "undefined") this.playerBar.currentTrackIdx = idx;
      this.playerBar.currentTrackId =
        this.playerBar.musicList[this.playerBar.currentTrackIdx].id;

      if (this.isMobile) {
        this.audioPlayer.selectTrackById(this.playerBar.currentTrackId);
      } else {
        this.getAudioTrack().then(() => {
          this.restartAudioPlayer();
        });
      }
    },

    selectTrackAndPlay(idx?: number) {
      if (typeof idx !== "undefined") this.playerBar.currentTrackIdx = idx;

      this.playerBar.currentTrackId =
        this.playerBar.musicList[this.playerBar.currentTrackIdx].id;

      if (this.isMobile) {
        this.audioPlayer.playTrackById(this.playerBar.currentTrackId);
      } else {
        this.getAudioTrack().then(() => {
          this.playerBar.playing = true;
          this.restartAudioPlayer(true);
        });
      }
    },

    nextAudioTrack() {
      ++this.playerBar.currentTrackIdx;
      if (
        this.playerBar.currentTrackIdx >
        this.playerBar.musicList.length - 1
      ) {
        this.playerBar.currentTrackIdx = 0;
      }
      this.playerBar.currentTrackId =
        this.playerBar.musicList[this.playerBar.currentTrackIdx].id;

      if (this.isMobile) {
        this.audioPlayer.skipForward();
      } else {
        this.selectTrack(this.playerBar.currentTrackIdx);
      }
    },

    playBackTrack() {
      //seek to the start of track
      if (this.isMobile) {
        this.playerBar.currentPosition = 0;
        this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
            this.playerBar.currentPosition
        );
        this.audioPlayer.seekTo(this.playerBar.currentPosition);
      } else {
        this.audioRef.currentTime = 0;
      }
    },

    prevAudioTrack() {
      if (this.playerBar.currentPosition > 20) {
        //seek to the start of track
        if (this.isMobile) {
          this.playerBar.currentPosition = 0;
          this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
            this.playerBar.currentPosition
          );
          this.audioPlayer.seekTo(this.playerBar.currentPosition);
        } else {
          this.audioRef.currentTime = 0;
        }
      } else {
        //switch to the previous track
        --this.playerBar.currentTrackIdx;
        if (this.playerBar.currentTrackIdx < 0)
          this.playerBar.currentTrackIdx = 0;
        this.playerBar.currentTrackId =
          this.playerBar.musicList[this.playerBar.currentTrackIdx].id;

        if (this.isMobile) {
          this.audioPlayer.skipBack();
        } else {
          this.selectTrackAndPlay(this.playerBar.currentTrackIdx);
        }
      }
    },

    changeCurrentPosition(delta: number): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        if (this.isMobile) {
          this.playerBar.currentPosition = Math.floor(
            this.playerBar.currentPosition + delta
          );
          this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
            this.playerBar.currentPosition
          );
          this.audioPlayer.seekTo(this.playerBar.currentPosition).then(() => {
            resolve(true);
          });
        } else {
          this.audioRef.currentTime = this.audioRef.currentTime + delta;
          resolve(true);
        }
      });
    },

    setCurrentPosition(value: number): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        if (this.isMobile) {
          this.playerBar.currentPosition = Math.floor(value);
          this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
            this.playerBar.currentPosition
          );
          this.audioPlayer.seekTo(value).then(() => {
            resolve(true);
          });
        } else {
          this.audioRef.currentTime = value;
          resolve(true);
        }
      });
    },

    async getAudioTrack(
      trackId?: string,
      trackMimeType?: string
    ): Promise<string> {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      return new Promise<string>((resolve) => {
        if (this.playerBar.musicList.length < 1) return resolve("");

        const getTrackId = trackId
          ? trackId
          : this.playerBar.musicList[this.playerBar.currentTrackIdx].id;
        const getTrackMimeType = trackMimeType
          ? trackMimeType
          : this.playerBar.musicList[this.playerBar.currentTrackIdx].mimeType;

        // Check if track is from server (path starts with "releases/")
        const isServerTrack = getTrackId.startsWith('releases/');

        if (
          this.isMobile &&
          (this.playerBar.offline || this.globalContext.offlineMode)
        ) {
          Filesystem.getUri({
            path: `${this.playerBar.offlineDirectory
              }/${getTrackId}.${this.mimeExtensions.get(getTrackMimeType)}`,
            directory: Directory.Data,
          }).then((res) => {
            this.trackPath = `${res.uri}`;
            resolve(this.trackPath);
          });
        } else if (isServerTrack) {
          // Use server API for releases
          const options = {
            url: `${process.env.VUE_APP_API_URL}api/releases/stream-request?path=${encodeURIComponent(getTrackId)}`,
            headers: { Authorization: `Bearer ${token}` },
            readTimeout: 60000,
          };
          
          CapacitorHttp.get(options)
            .then((response) => {
              if (response.data && response.data.streamUrl) {
                this.trackPath = response.data.streamUrl;
              } else {
                // Fallback to direct streaming (should not happen)
                this.trackPath = `${process.env.VUE_APP_API_URL}api/releases/stream?path=${encodeURIComponent(getTrackId)}`;
              }
              resolve(this.trackPath);
            })
            .catch(() => {
              // Fallback to direct streaming
              this.trackPath = `${process.env.VUE_APP_API_URL}api/releases/stream?path=${encodeURIComponent(getTrackId)}`;
              resolve(this.trackPath);
            });
        } else {
          // Original Google Drive logic
          const options = {
            url: `${process.env.VUE_APP_API_URL
              }api/google/media/storage/${getTrackId}.${this.mimeExtensions.get(
                getTrackMimeType
              )}`,
            headers: { Authorization: `Bearer ${token}` },
            readTimeout: 60000,
          };
          if (this.globalContext.musicBeta) {
            // this.trackPath = `${process.env.VUE_APP_API_URL}api/google/music-beta/${getTrackId}`;
            CapacitorHttp.get(options)
              .then((response) => {
                if (response.data) {
                  this.trackPath = `${process.env.VUE_APP_MEDIA_URL
                    }media/${getTrackId}.${this.mimeExtensions.get(
                      getTrackMimeType
                    )}`;
                } else {
                  this.trackPath = `${process.env.VUE_APP_API_URL}api/google/music/${getTrackId}`;
                }
                resolve(this.trackPath);
              })
              .catch(() => {
                this.trackPath = `${process.env.VUE_APP_API_URL}api/google/music/${getTrackId}`;
                resolve(this.trackPath);
              });
          } else {
            CapacitorHttp.get(options)
              .then((response) => {
                if (this.isMobile && response.data) {
                  this.trackPath = `${process.env.VUE_APP_MEDIA_URL
                    }media/${getTrackId}.${this.mimeExtensions.get(
                      getTrackMimeType
                    )}`;
                } else {
                  this.trackPath = `${process.env.VUE_APP_API_URL}api/google/music/${getTrackId}`;
                }
                resolve(this.trackPath);
              })
              .catch(() => {
                this.trackPath = `${process.env.VUE_APP_API_URL}api/google/music/${getTrackId}`;
                resolve(this.trackPath);
              });
          }
        }
      });
    },

    rangeDragging(value: string) {
      this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
        Number(value)
      );
    },
    rangeDragStart() {
      if (!this.isMobile) {
        this.audioRef.pause();
      }
    },
    rangeDragEnd() {
      if (this.isMobile) {
        this.audioPlayer.seekTo(Math.floor(this.playerBar.currentPosition));
      } else {
        this.audioRef.currentTime = this.playerBar.currentPosition;
        this.playerBar.currentTrackCurrentTime = this.mediaUtils.formatTime(
          this.playerBar.currentPosition
        );
        this.audioRef.play();
      }
    },

    getAlbumImage() {
      if (this.playerBar.programShortName) {
        this.logoService.getProgramLogo(this.playerBar.programShortName).then((url) => {
          this.playerAlbumImage = url;
        });
        return;
      }
      if (!this.playerBar.playlistImage || this.playerBar.playlistImage == "")
        return;

      if (this.globalContext.offlineMode) {
        let storedImageExists = false;
        Filesystem.readdir({
          path: this.playerBar.playlistImageDir,
          directory: Directory.Data,
        }).then((response) => {
          storedImageExists = response.files.length > 0;

          if (storedImageExists) {
            Filesystem.getUri({
              path: `${this.playerBar.playlistImageDir}/${this.playerBar.playlistImage}`,
              directory: Directory.Data,
            }).then((storedImage) => {
              this.playerAlbumImage = Capacitor.convertFileSrc(storedImage.uri);
            });
          }
        });
      } else {
        Preferences.get({ key: "jwt" }).then((tokenQuery) => {
          const baseUrl = process.env.VUE_APP_API_URL || process.env.VUE_APP_API_EXT_URL || "";
          const shortName = (this.playerBar.playlistImage || "").replace(/\.(png|jpg|jpeg)$/i, "");
          if (shortName) {
            this.logoService.getProgramLogo(shortName).then((url) => {
              this.playerAlbumImage = url;
            });
          } else {
            CapacitorHttp.get({
              url: `${baseUrl}api/google/file/base64/name/${this.playerBar.playlistImage}`,
              headers: { Authorization: `Bearer ${tokenQuery.value}` },
              readTimeout: 60000,
            }).then((response) => {
              this.playerAlbumImage = `data:image/jpg;base64,${response.data}`;
            });
          }
        });
      }
    },

    async checkAppUpdate() {
      if (isPlatform("ios")) {
        await Browser.open({
          url: "",
        }).catch((err) => {
          console.log(err);
        });
      } else if (isPlatform("android")) {
        await Browser.open({
          url: "https://play.google.com/store/apps/details?id=com.growapp.ligaapp",
        }).catch((err) => {
          console.log(err);
        });
      }
    },

    async openTelegramSupport() {
      menuController.close();
      const url = "https://t.me/+LU7nvmUqFBk2ZWJi";
      if (Capacitor.isNativePlatform()) {
        await Browser.open({ url }).catch((err) => console.error("Open Telegram support:", err));
      } else {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    },
  },
});
</script>

<style scoped>
.menu-notification-flag {
  background: var(--ion-color-danger);
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.logo {
  margin: 1em 0.5em 0.5em 1em;
  display: flex;
  flex-flow: column;
  align-content: center;
}

.app-icon {
  color: white;
  margin-bottom: 0.05em;
}

ion-fab {
  margin: 5vh 3vw 0 3vw;
}

ion-fab-button {
  --background: transparent;
  --background-hover: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --box-shadow: none;
  width: 8vh;
  height: 8vh;
}

ion-tab-bar {
  --background: rgba(30, 30, 30) !important;
  background: rgba(30, 30, 30) !important;
}

.help-button {
  --background: transparent;
  --background-hover: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --box-shadow: none;
}

.help-button ion-icon {
  color: white;
  font-size: 1.3em;
}

.menu-list {
  background: #1e1e1e !important;
}

ion-title,
ion-label {
  color: white;
}

.menu-header-background {
  --background: var(--ion-color-orange);
  background: var(--ion-color-orange);
}

.menu-header {
  height: 25%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  position: relative;
}

.menu-logo {
  margin: 20% 15% 0 30%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  height: 15%;
  width: 50%;
}

.menu-header ion-avatar {
  position: absolute;
  left: 10px;
  bottom: 5px;
}

.menu-header ion-label {
  position: absolute;
  left: 30%;
  bottom: 20%;
  color: var(--ion-color-orange);
  font-family: "NotoSans";
  font-weight: bold;
  font-size: 1em;
  white-space: initial;
}

.menu-header-subname {
  position: absolute;
  left: 30%;
  bottom: 10%;
  color: white;
  font-family: "NotoSans";
  font-size: 0.8em;
  display: flex;
  align-items: center;
}

.login-button {
  position: absolute;
  right: 10px;
  bottom: 0;
  --background: #FF8113;
  --background-activated: #e2ae80;
  width: 30%;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
}

.menu-avatar {
  align-self: flex-start;
  display: flex;
  --inner-padding-top: 5px;
  --inner-padding-bottom: 5px;
}

.menu-avatar ion-avatar {
  width: 55px !important;
  height: 55px !important;
  margin-inline-end: 15px !important;
}

.menu-avatar ion-label {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.menu-user-account {
  color: white;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 0.7em;
}

.menu-user-name {
  color: var(--ion-color-orange);
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  font-size: 1em;
  white-space: initial;
}

.menu-header-fake {
  width: 100%;
  height: 20px;
}

.menu-footer {
  --background: #1e1e1e;
  font-size: 0.9em !important;
}
/* Футер меню — тёмный фон, чтобы текст был читаемым (app-footer-style по умолчанию оранжевый) */
ion-menu .menu-footer ion-toolbar.app-footer-style {
  --background: #1e1e1e !important;
  background: #1e1e1e !important;
  --color: rgba(255, 255, 255, 0.95);
  color: rgba(255, 255, 255, 0.95);
}
.menu-footer ion-title.menu-footer {
  color: rgba(255, 255, 255, 0.95);
}
.menu-footer-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.25em;
  padding: 0 8px 4px;
  font-size: 0.85em;
}
.menu-footer-link {
  color: #ffb380;
  cursor: pointer;
  text-decoration: none;
}
.menu-footer-link:hover {
  color: #ffcc99;
  text-decoration: underline;
}
.menu-footer-sep {
  color: rgba(255, 255, 255, 0.5);
  user-select: none;
}
.menu-footer-payee {
  margin: 0 8px 8px;
  font-size: 0.8em;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
}
.menu-footer-payee .menu-footer-link {
  color: #ffb380;
}
.menu-footer-payee .menu-footer-link:hover {
  color: #ffcc99;
}

.menu-content {
  --background: #1e1e1e;
  width: unset !important;
}

.menu-item {
  cursor: pointer;
  --background: #1e1e1e !important;
  --border-color: rgba(160, 165, 171, 0.2);
  color: white;
}

.menu-item:last-child {
  --border-style: unset !important;
}

.menu-label {
  margin-left: 1em;
  margin-top: 0.8em;
  font-size: 1em;
}

.menu-list ion-item-divider {
  --background: #2a2a2a;
  --color: rgba(255, 255, 255, 0.7);
  min-height: 32px;
}

.menu-section-label {
  font-size: 0.85em;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.menu-fab-button {
  z-index: 1000;
}

.selected-route {
  color: var(--ion-color-orange) !important;
}

.music-player-container {
  min-height: 60px !important;
  max-height: 100vh;
  width: calc(100vw - 30px);
  background: transparent;
  padding: 10px 15px 0 15px;
  position: absolute;
  bottom: 12%;
  left: 15px;
  border-radius: 20px;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.music-player-bottom-container {
  bottom: 5% !important;
}

.w-full-player {
  width: 100%;
  height: 80vh;
  background: rgba(8, 2, 16, 0.7);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(4.9px);
  -webkit-backdrop-filter: blur(4.9px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.w-full-player-header {
  margin-top: 1em;
  padding: 0 5%;
  display: flex;
}
.w-full-player-header img {
  height: 85%;
  width: 20%;
  border-radius: 15px;
  align-self: flex-start;
  object-fit: contain;
}

.micro-player-container {
  height: 50px;
  background: transparent;
  position: absolute;
  bottom: 12%;
  left: 0;
  padding: 0 5%;
  display: flex;
  flex-flow: column;
}
.micro-player-container {
  width: 50px;
  height: 60px;
  transition: .5s;
}
.micro-player-container-ext {
  width: 100vw;
  transition: .5s;
}

.micro-player {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: rgba(8, 2, 16, 0.7);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(4.9px);
  -webkit-backdrop-filter: blur(4.9px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  padding: .5em 2em;
  position: relative;
}
.w-track-index {
  font-family: 'Montserrat';
  font-size: 2.5em;
  font-weight: bold;
  color: rgba(255, 255, 255, .1);
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.w-track-index-ext {
  width: 20%;
  height: 100%;
}
.micro-track-time {
  font-family: 'Montserrat';
  font-weight: 900;
  font-size: .4em;
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.micro-player-controls {
  width: 80%;
  height: 100%;
  display: flex;
  align-items: center;
}
.micro-track-name {
  color: white;
  font-weight: bold;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 50%;
}

.micro-player-buttons {
  width: 100%;
  height: 60%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  font-family: 'Montserrat';
  font-weight: 900;
  font-size: .8em;
}

.w-player {
  width: 100%;
  height: 150px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  position: relative;
  overflow: hidden;
}

.w-player::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.1) 0%, 
    rgba(255, 255, 255, 0.05) 50%, 
    rgba(255, 255, 255, 0.02) 100%);
  pointer-events: none;
  border-radius: 20px;
}

.w-track-name {
  font-family: 'NotoSans';
  font-weight: 300;
  color: white;
  position: absolute;
  top: 1em;
  left: 2em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 50%;
}

.w-playlist-name {
  font-family: 'Montserrat';
  font-weight: 900;
  font-size: .8em;
  color: white;
  position: absolute;
  top: 3em;
  left: 2em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 50%;
}

.w-player-range {
  background: transparent !important;
  --bar-background: white;
  --bar-background-active: var(--liga-color-orange);
  --height: 1px;
  --bar-height: 5px;
  --knob-size: 15px;
  --bar-border-radius: 15px;
  position: absolute;
  top: 3.5em;
  left: 0;
  z-index: 100;
  width: 100%;
  padding: 0 5%;
}

.w-player-buttons {
  position: absolute;
  top: 5.5em;
  left: 0;
  padding: 0 5%;
  z-index: 100;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.w-service-player-buttons {
  position: absolute;
  top: 0;
  right: 1em;
  display: flex;
  flex-wrap: nowrap;
  width: 30%;
  align-items: flex-start;
  justify-content: flex-end;
}

.player-label {
  color: white;
}

.player-button {
  --background: transparent !important;
  --background-activated: transparent !important;
  font-size: 1.1em;
  --padding-start: 0;
  --padding-end: 0;
  --box-shadow: 0;
  font-family: 'Montserrat';
  font-weight: 700;
}

.player-button-icon {
  color: white !important;
}

.player-top-icon {
  color: rgba(255, 255, 255, 0.5) !important;
  position: absolute;
  left: 50%;
  top: -5px;
  transform: translateX(-50%);
}

.reverse-icon {
  transform: rotateY(180deg);
}

.playlist-collapse-button {
  position: absolute;
  top: 1em;
  right: 8%;
  --background: transparent !important;
  --background-activated: transparent !important;
  width: 50px;
  font-size: 1.2em;
  --padding-start: 0;
  --padding-end: 0;
  --box-shadow: 0;
  color: white;
  z-index: 100;
}

.playlist-header {
  width: 100%;
  height: 30%;
  --background: #121212;
  --padding-top: 20px;
  --padding-bottom: 30px;
}

.player-playlist-container {
  --padding-top: 10px;
  --padding-end: 0 !important;
  width: 100%;
  height: 75%;
  --background: #121212 !important;
}

.player-playlist-range {
  background: #121212 !important;
}

.playlist-header-wrapper {
  padding-top: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.playlist-header img {
  margin-left: 20px;
  height: 85%;
  width: 20%;
  border-radius: 15px;
  align-self: flex-start;
  object-fit: contain;
}

.playlist-header-text-wrapper {
  display: flex;
  flex-flow: column nowrap;
  margin-left: 20px;
  width: 65%;
  max-height: 100%;
  overflow: hidden;
}

.playlist-header-text-wrapper p {
  color: rgba(255, 255, 255, 0.8);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-block: 0 !important;
  font-family: 'NotoSans';
  font-weight: 300;
  font-size: .8em;
}

.playlist-header-text-wrapper h1 {
  font-weight: bold;
  align-self: flex-start;
  margin-block: 0 !important;
  color: white;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 85%;
  font-family: 'Montserrat';
  font-weight: 900;
  font-size: .8em;
  text-transform: uppercase;
}

.playlist-header-text-wrapper h3 {
    color: rgba(255, 255, 255, 0.8);
  align-self: flex-start;
  margin-block: 0 !important;
  font-size: 1em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-block: 0 !important;
  font-family: 'Montserrat';
  font-weight: 500;
  font-size: .75em;
}

.play-list-content {
  width: 100%;
  height: 100vh;
  --background: #1e1e1e !important;
  position: relative;
  z-index: 1100;
}

.playlist-play-button-wrapper {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  max-width: 300px;
}

.playlist-play-button {
  height: 40px;
  width: 30%;
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  --border-radius: 14px;
  color: white;
}

.playlist-play-button-sm {
  width: 30% !important;
}

.player-item {
  --background: transparent;
  color: white;
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  font-family: 'Montserrat';
  font-weight: 500;
  font-size: .8em;
  text-transform: uppercase
}

.player-playlist {
  max-height: 60%;
  overflow: scroll;
  background: transparent;
  overflow-x: hidden;
}

.player-playlist ion-note {
  font-size: 1em;
  color: white;
}

.player-playlist::-webkit-scrollbar {
  display: none;
}

.player-playlist::-webkit-scrollbar-track {
  display: none;
}

.fake-footer {
  height: 10vh;
}

.player-compact-container {
  width: 100%;
  height: 60px;
  position: relative;
  background: #121212 !important;
}

.w-full-player-range {
  position: relative;
  width: 100%;
  height: 2.5em;
  margin-top: 0.5em;
}

.player-range {
  background: transparent !important;
  --bar-background: white;
  --bar-background-active: var(--liga-color-orange);
  --height: 1px;
  --bar-height: 5px;
  --knob-size: 15px;
  --bar-border-radius: 15px;
  z-index: 100;
  width: 100%;
  padding: 0 5%;
}

.micro-range {
  position: absolute;
  bottom: 0;
  left: 0;
}

.player-compact-controls {
  position: absolute;
  left: 5%;
  top: -10px;
  z-index: 100;
}

.player-compact-bottom-safe-area {
  width: 100%;
  height: 20px;
  background: #121212;
}

.player-track-name {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -30%);
  z-index: 100;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 40%;
}

.player-program-name {
  position: absolute;
  left: 50%;
  top: 60%;
  transform: translate(-50%, -60%);
  z-index: 100;
  font-size: 0.8em;
  color: var(--ion-color-orange);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 40%;
}

.player-current-time,
.player-total-time {
  font-family: 'Montserrat';
  font-size: 0.8em;
  font-weight: bold;
  position: absolute;
  left: 1em;
  top: 5em;
  transform: translate(0, 1em);
  z-index: 120;
}

.player-total-time {
  right: 1em !important;
  left: unset !important;
}

.playlist-current-time,
.playlist-total-time {
  font-family: 'Montserrat';
  font-size: 0.8em;
  font-weight: bold;
  position: absolute;
  left: 5%;
  bottom: 10%;
  z-index: 120;
}

.playlist-total-time {
  right: 5% !important;
  left: unset !important;
}

.player-close-button {
  position: absolute;
  right: 5%;
  top: -10px;
  z-index: 100;
}

.player-extend-button {
  position: absolute;
  top: 15%;
  left: 5%;
  transform: translate(0, -15%);
  z-index: 100;
  font-size: 1.5em;
}

.selected-track {
  color: #FF8113;
}

.playlist-label {
  margin-inline-end: 0 !important;
  flex: 3;
}

.full-player-controls {
  width: 100%;
  --background: #1e1e1e;
}

.player-buttons {
  display: flex;
  flex: row nowrap;
  justify-content: space-around;
  align-items: center;
  border-radius: 5px;
}

.player-timer {
  display: flex;
  flex: row nowrap;
  justify-content: space-around;
  align-items: center;
  width: 25%;
  opacity: 0.8;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 5px;
  border: 1px solid white;
}

.player-timer ion-icon {
  font-size: 1.5em;
}

.player-timer ion-input {
  font-family: 'Montserrat';
  color: white;
}

.player-wrapper {
  --background: #1f1f1f !important;
}

ion-tab-bar {
  height: 8%;
}

/* Modern iOS 26 Style Bottom Bar */
.modern-tab-bar {
  --background: rgba(255, 255, 255, 0.1);
  --border: none;
  height: 90px;
  padding: 8px 20px 20px 20px;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 25px 25px 0 0;
  margin: 0 15px;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.modern-tab-bar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.1) 0%, 
    rgba(255, 255, 255, 0.05) 50%, 
    rgba(255, 255, 255, 0.02) 100%);
  pointer-events: none;
}

.modern-tab-button {
  --color: rgba(255, 255, 255, 0.6);
  --color-selected: #ffffff;
  --background: transparent;
  --background-selected: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  margin: 0 4px;
  padding: 8px 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.modern-tab-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.05);
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 16px;
}

.modern-tab-button:hover::before,
.modern-tab-button.selected::before {
  opacity: 1;
}

.modern-tab-button.selected {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 165, 0, 0.3);
}

.tab-icon-wrapper {
  position: relative;
  z-index: 2;
  margin-bottom: 4px;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modern-tab-button.selected .tab-icon-wrapper {
  transform: scale(1.1);
}

.tab-icon-wrapper ion-icon {
  font-size: 24px;
  transition: all 0.3s ease;
}

.modern-tab-button.selected .tab-icon-wrapper ion-icon {
  color: var(--ion-color-orange);
  filter: drop-shadow(0 0 8px rgba(255, 165, 0, 0.4));
}

.tab-label {
  font-size: 11px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
  opacity: 0.8;
}

.modern-tab-button.selected .tab-label {
  opacity: 1;
  color: var(--ion-color-orange);
}

/* Responsive Design for Modern Tab Bar */
@media (max-width: 768px) {
  .modern-tab-bar {
    margin: 0 10px;
    padding: 6px 15px 15px 15px;
    height: 80px;
  }
  
  .modern-tab-button {
    margin: 0 2px;
    padding: 6px 8px;
    min-height: 55px;
  }
  
  .tab-icon-wrapper ion-icon {
    font-size: 20px;
  }
  
  .tab-label {
    font-size: 10px;
  }
}

@media (min-width: 1024px) {
  .modern-tab-bar {
    margin: 0 25px;
    padding: 10px 25px 25px 25px;
    height: 100px;
  }
  
  .modern-tab-button {
    margin: 0 6px;
    padding: 10px 16px;
    min-height: 70px;
  }
  
  .tab-icon-wrapper ion-icon {
    font-size: 28px;
  }
  
  .tab-label {
    font-size: 12px;
  }
}

/* Веб: нижнее меню по центру, заметная ширина */
.modern-tab-bar.tab-bar-web {
  min-width: 360px;
  max-width: 560px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  height: 68px;
  padding: 10px 20px 14px;
  border-radius: 28px 28px 0 0;
  box-shadow: 0 -4px 28px rgba(0, 0, 0, 0.18);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  --background: rgba(28, 28, 28, 0.95);
  background: rgba(28, 28, 28, 0.95);
  padding-bottom: max(14px, env(safe-area-inset-bottom));
}

.modern-tab-bar.tab-bar-web::before {
  border-radius: 28px 28px 0 0;
}

.modern-tab-bar.tab-bar-web .modern-tab-button {
  min-height: 48px;
  padding: 6px 12px;
  margin: 0 2px;
  border-radius: 20px;
}

.modern-tab-bar.tab-bar-web .modern-tab-button::before {
  border-radius: 20px;
}

.modern-tab-bar.tab-bar-web .tab-icon-wrapper {
  margin-bottom: 2px;
}

.modern-tab-bar.tab-bar-web .tab-icon-wrapper ion-icon {
  font-size: 20px;
}

.modern-tab-bar.tab-bar-web .tab-label {
  font-size: 10px;
  letter-spacing: 0.03em;
  text-transform: none;
  font-weight: 500;
}

.modern-tab-bar.tab-bar-web .modern-tab-button.selected {
  transform: none;
  box-shadow: 0 2px 12px rgba(232, 93, 4, 0.25);
}

.modern-tab-bar.tab-bar-web .modern-tab-button.selected .tab-icon-wrapper {
  transform: scale(1.05);
}

/* Dark mode enhancements */
@media (prefers-color-scheme: dark) {
  .modern-tab-bar {
    --background: rgba(0, 0, 0, 0.3);
    border-top: 1px solid rgba(255, 255, 255, 0.05);
  }
  
  .modern-tab-bar::before {
    background: linear-gradient(135deg, 
      rgba(255, 255, 255, 0.05) 0%, 
      rgba(255, 255, 255, 0.02) 50%, 
      rgba(0, 0, 0, 0.1) 100%);
  }
  
  .w-player {
    background: rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.08);
  }
  
  .w-player::before {
    background: linear-gradient(135deg, 
      rgba(255, 255, 255, 0.05) 0%, 
      rgba(255, 255, 255, 0.02) 50%, 
      rgba(0, 0, 0, 0.2) 100%);
  }
}

/* Legacy styles for compatibility */
.release-tab-button {
  --color-selected: var(--ion-color-orange);
}

.release-tab-button ion-icon {
  font-size: 2.5em !important;
}

.release-tab-button ion-badge {
  font-family: 'Montserrat';
}

.player-extended-container {
  width: 100%;
  height: 50px;
  background: #121212 !important;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
  padding-top: 1em;
  padding-bottom: 1em;
}

.player-extended-l-button {
  font-size: 1.5em;
}

.player-extended-sm-button {
  font-size: 1em;
}

.player-extended-xsm-button {
  font-size: 0.7em;
}

.player-extended-minus-seconds {
  position: relative;
}

.player-extended-minus-seconds::before {
  content: "-15s";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
}

.player-extended-add-seconds {
  position: relative;
}

.player-extended-add-seconds::before {
  content: "+15s";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
}

.button-top-label {
  font-size: 0.8em;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
}

.player-settings-container {
  width: 100%;
  height: 100px;
  background: #121212 !important;
}

.player-settings-container ion-item {
  --background: #121212 !important;
  --color: white;
}

.player-settings-container ion-toggle {
  --background-checked: var(--ion-color-orange);
  --background: #5a5a5a;
  --handle-background-checked: white;
}

.menu-badge {
  --background: var(--ion-color-orange);
  --color: white;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.access-denied-card-modal {
  --background: rgba(67, 67, 67, 0.5) !important;
  --backdrop-opacity: 0.3;
}

.access-denied-card-container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-flow: column;
  height: 100vh;
}

.access-denied-card-container ion-card {
  padding: 20px;
  max-height: 90%;
  overflow: scroll;
  --background: #1f1f1f !important;
}

.access-denied-card-container ion-card-title {
  color: white;
  font-weight: bold;
  font-size: 1.8em;
  letter-spacing: 0.07em;
}

.access-denied-card-container ion-card-content {
  color: rgba(255, 255, 255, 0.5);
  font-weight: bold;
  font-size: 1em;
  letter-spacing: 0.07em;
}

.access-denied-card-img {
  display: flex;
  justify-content: center;
}

.access-denied-card-img img {
  width: 70%;
}

.access-denied-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.access-denied-btn-container ion-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
}

.download-progress {
  font-size: 3em !important;
  color: var(--ion-color-orange) !important;
}

.play-now-container {
  --background: transparent;
  color: white;
  --border-radius: 15px;
}

.play-now-container ion-content {
  --background: transparent;
}

.play-now-container ion-item {
  --background: rgba(67, 67, 67, 0.7);
}

.play-now-container ion-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  width: 80%;
  height: 50px;
  font-family: 'Montserrat';
  font-weight: bold;
  --border-radius: 14px;
}

.play-now-container .cancel-button {
  --background: #eb445a !important;
  --background-activated: #e95e70 !important;
  margin-top: 2em;
}

.play-now-container ion-label {
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  color: white;
}

.play-now-container div {
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

/* Animation */
.extended-player-enter-active {
  max-height: 50px;
  transition: max-height 0.4s ease-out;
}

.extended-player-enter-from {
  max-height: 0;
}

.extended-player-leave-active {
  opacity: 0;
  transition: opacity 0.1s ease-out;
}

/* Animation */
.playlist-player-enter-active {
  max-height: 100vh;
  transition: max-height 0.4s ease-out;
}

.playlist-player-enter-from {
  max-height: 0;
}

.playlist-player-leave-active {
  opacity: 0;
  transition: opacity 0.1s ease-out;
}

/* Модальное окно согласия с политикой конфиденциальности */
:deep(.privacy-consent-modal) ion-toolbar {
  --background: var(--ion-color-dark);
  --color: #fff;
}
:deep(.privacy-consent-modal) .privacy-consent-text {
  margin-bottom: 1em;
  line-height: 1.5;
}
:deep(.privacy-consent-modal) .privacy-consent-link {
  color: var(--ion-color-orange);
  text-decoration: underline;
}
:deep(.privacy-consent-modal) .privacy-consent-accept-btn {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  margin-top: 1.5em;
}
</style>